export default __webpack_public_path__ + "static/media/DissectIt_Step3.24010b7b.png";